import React from 'react';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'daily_check_in_out_rulesets',
  namespace: 'checkInOutRuleset',
  mountedUrl: '/daily-rental/check-in-out-rulesets',
  title: 'Check in/out rulesets',
  columns: [
    { attribute: 'name' },
  ],
  useQuickSearch: true,
});



// import React from 'react';
// import { ListingObjects } from 'hyperdb-utils';
// import { HyperdbListing } from '../../../../hyperdb';
//
// class Listing extends React.Component {
//   constructor(props) {
//     super(props);
//   }
//   render() {
//     return (
//       <ListingObjects
//         { ...this.props }
//         deleteMessage="Are you sure you want to delete this rental ruleset ?"
//       />
//     );
//   }
// }
//
// export default HyperdbListing({
//   CustomComponent: Listing,
//   collectionName: 'daily_check_in_out_rulesets',
//   namespace: 'checkInOutRuleset',
//   mountedUrl: '/daily-rental/check-in-out-rulesets',
//   title: 'Rental rulesets',
//   columns: [
//     { attribute: 'name', label: 'property' },
//     { label: 'defined', sortable: false, value: (object) => !!object.daily_check_in_out_ruleset.value[1] ? <i className="fas fa-check" /> : null },
//   ],
//   canCreate: false,
//   canDelete: (object) => !!object.daily_check_in_out_ruleset.value[1],
//   onEdit: (object, props) => {
//     if (!object.daily_check_in_out_ruleset.value[1]) {
//       props.api.routing.redirect(props.router, `/daily-rental/check-in-out-rulesets/new?propertyId=${object.id}`);
//     } else {
//       props.api.routing.redirect(props.router, `/daily-rental/check-in-out-rulesets/${object.daily_check_in_out_ruleset.value[1]}?propertyId=${object.id}`);
//     }
//   },
//   onDelete: (object, props) => {
//     props.api.checkInOutRuleset.deleteObject(object.daily_check_in_out_ruleset.value[1]);
//   },
// });



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/check-in-out-ruleset/containers/Listing.jsx